import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFilterRemove$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFilterRemove extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'd4031284e47f99d84bca0c92d2f47ef2a08ed4ad', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'cf5de554ba58e7110d3bd240c8cd32ad9f977dfa', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '864a4e936bd320536ad25235447d7f50ef150bfc', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 6.25h3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-3V9.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5zM8 11h.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5v-1.75h-4a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h4V11.5A.5.5 0 0 1 8 11M3 6.75a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5zM21 16a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-2.703-1.237a.5.5 0 0 0 0-.707l-.353-.354a.5.5 0 0 0-.707 0l-1.238 1.238-1.237-1.238a.5.5 0 0 0-.707 0l-.354.354a.5.5 0 0 0 0 .707L14.94 16l-1.24 1.238a.5.5 0 0 0 0 .707l.354.353a.5.5 0 0 0 .707 0l1.237-1.237 1.238 1.237a.5.5 0 0 0 .707 0l.353-.353a.5.5 0 0 0 0-.707L17.06 16z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-filter-remove", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-filter-remove"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-filter-remove":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFilterRemove$1);
            }
            break;
    } });
}

const CosmosIconFilterRemove = CosmosIconFilterRemove$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFilterRemove, defineCustomElement };
